import React from 'react';
import Image from './Image';
import { HTMLContent } from '../components/Content';

const PropertyCollections = ({ collectionTiles, title, subtitle }) => {
  
  const renderCollectionTiles = () => {
    if (!!collectionTiles) {
      return collectionTiles.map((tile) => (
        <div className='property-collection'>
            <div class="property-collection-title-wrapper">
              <div class="property-collection-icon">
                <Image imageInfo={{ image: tile.icon }} />
              </div>
              <h2 class="property-collection-title">
                { tile.title }
              </h2>
            </div>
            <div class="property-collection-text">
              { tile.text }
            </div>
          </div>
      ));
    }
    return null;
  };

  return (
    <>
    <div class="properties-header">
      <h1>{ title }</h1>
      <HTMLContent content={ subtitle } />
    </div>
    <div className='property-collections-wrapper'>
      { renderCollectionTiles() }
    </div>
    </>
  );
};

export default PropertyCollections;
